/* istanbul ignore file */
import { IPublicClientApplication } from "@azure/msal-browser";

import { AppDispatch } from "../../state-management/store";
// eslint-disable-next-line node/no-extraneous-import
import { History } from "history";
import {
  setLoggedIn,
  updateAdminModeState,
} from "../../state-management/slices/global/global.slice";
import { IAppConfig } from "../types/config.types";

export class AuthSericeEntra {
  private dispatch: AppDispatch;
  private static instance: AuthSericeEntra;
  public msalInstance: IPublicClientApplication;

  private constructor(
    dispatch: AppDispatch,
    msalInstance: IPublicClientApplication
  ) {
    this.dispatch = dispatch;
    this.msalInstance = msalInstance;
  }

  public static getInstance(
    dispatch: AppDispatch,
    msalInstance: IPublicClientApplication
  ): AuthSericeEntra {
    if (!AuthSericeEntra.instance) {
      AuthSericeEntra.instance = new AuthSericeEntra(dispatch, msalInstance);
    }

    return AuthSericeEntra.instance;
  }

  public async signin(appConfig: IAppConfig): Promise<void> {
    const tenantId = appConfig.azureTenantId;
    const clientId = appConfig.azureClientId;
    const scope = appConfig.azureScope;
    const accounts = this.msalInstance.getAllAccounts();
    if (accounts.length == 1) {
      const account = accounts[0];
      if (account?.tenantId === tenantId) {
        this.msalInstance.setActiveAccount(account);
      }
    }
    try {
      const loginRequest = {
        scopes: [`api://${clientId}/${scope}`],
      };

      this.msalInstance.loginRedirect(loginRequest);
    } catch (err) {
      console.log(err);
    }
  }

  public async signOut(history: History<unknown>): Promise<void> {
    const basename =
      window.location.origin + history.createHref({ pathname: "/" });

    try {
      this.msalInstance.logout({ postLogoutRedirectUri: basename });
      this.dispatch(updateAdminModeState(false));
      this.dispatch(setLoggedIn(false));
    } catch (err) {
      console.log({ err });
      throw err;
    }
  }
}
